module.exports = __webpack_public_path__ + "static/media/camera-white.029ac5ce.svg";